<template>
  <div ref="scrollRef" :style="{
    backgroundColor:HNewGameUIConfig.newGameUIType === 3 ?'#1f1f1f': 'white',
  }">
    <van-sticky v-if="tabList!=null || tag1List!=null || tag2List!=null" offset-top="46px">
      <div :style="{
          padding:'10px 10px 0 10px',
          display: 'flex',
          backgroundColor: HNewGameUIConfig.newGameUIType === 3 ?'#1f1f1f':'white',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }">
        <div v-if="tabList!=null" style="display:flex;flex-direction: row;align-items: center;">
          <div @click="clickTab(eachTab['TableType'])" v-for="eachTab in tabList" :key="eachTab['Name']">
              <div :style="hcf.getTextStyle({
                   color:selectTabType === eachTab['TableType']?'main':'#777',addSize:1,marginRight:15,
              })">
                {{eachTab["Name"]}}
              </div>
          </div>
        </div>

        <div v-if="tag1List!=null" style="margin-top: 5px;display:flex;flex-direction: row;align-items: center;">
          <div :style="{
            backgroundColor:selectTag1Id === eachTag['Id']?hcf.getMainColor():'#ddd',
            borderRadius:'4px',
            padding:'2px 10px 2px 10px ',
            marginRight:'10px',
          }" @click="clickTag1(eachTag['Id'])" v-for="eachTag in tag1List" :key="eachTag['Name']">
            <div :style="hcf.getTextStyle({
                   color:selectTag1Id === eachTag['Id']?'white':'#777',addSize:-1
              })">
              {{eachTag["Name"]}}
            </div>
          </div>
        </div>

        <div v-if="tag2List!=null" style="margin-top: 5px;display:flex;flex-direction: row;align-items: center;">
          <div :style="{
            backgroundColor:selectTag2Id === eachTag['Id']?hcf.getMainColor():'#ddd',
            borderRadius:'4px',
            padding:'2px 10px 2px 10px ',
            marginRight:'10px',
          }" @click="clickTag2(eachTag['Id'])" v-for="eachTag in tag2List" :key="eachTag['Name']">
            <div :style="hcf.getTextStyle({
                   color:selectTag2Id === eachTag['Id']?'white':'#777',addSize:-1
              })">
              {{eachTag["Name"]}}
            </div>
          </div>
        </div>

        <div :style="{
            width:'100%',
            height:'1px',
            backgroundColor: HNewGameUIConfig.newGameUIType === 3 ?'#333':'#eee',
            marginTop: '5px',
          }"/>
      </div>
    </van-sticky>
    <div :style="{
      marginBottom:tabList!=null && tag1List!=null && tag2List!=null?'0':'5px',
    }"/>
    <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
    >
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <div :style="{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          padding: '10px 13px 0 13px',
          columnGap:'13px',
          rowGap:'10px',
        }">
        <div v-for="(item,index) in list" :key="index">
          <EachGameItem :isFromSecondLobby="true" :eachRowCount="3" :eachImgWidth="eachImgWidth" :itemInfo="item" :favoriteCallback="item['FavoriteCallback']"/>
        </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-back-top style="color: white;background-color: var(--ct-main-color);"/>
  </div>
</template>

<script setup>
  import {ref, onMounted, onUnmounted, watch} from 'vue';
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useUserStore} from "@/stores/useUser.js";
  import EachGameItem from "@/components/pages/EachGameItem.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const props = defineProps(["innerNavId", "childNavId"]);
  const list = ref([]);
  const loading = ref(false);
  const finished = ref(false);
  const refreshing = ref(false);
  const useHttp = useHHttp();
  const user = useUserStore();
  const scrollRef = ref(null);
  let eachSpace = 13;
  // 同首页: 用 clientWidth 兜底 + resize 重算, 兼容被 hsxs_h5 以 <iframe srcdoc> 内嵌时首帧视口偏大的情况
  function calcEachImgWidth() {
    const vw = document.documentElement.clientWidth || window.innerWidth;
    return (vw - 90 - eachSpace * (3 + 1)) / 3;
  }
  const eachImgWidth = ref(calcEachImgWidth());
  function onViewportResize() {
    const w = calcEachImgWidth();
    if (w > 0 && w !== eachImgWidth.value) eachImgWidth.value = w;
  }
  onMounted(() => {
    onViewportResize();
    requestAnimationFrame(onViewportResize);
    setTimeout(onViewportResize, 300);
    window.addEventListener('resize', onViewportResize);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', onViewportResize);
  });

  watch(() => props.childNavId, () => {
    window.scrollTo({
      top: -10,
    });
    selectTabType.value = 0;
    selectTag1Id.value = 0;
    selectTag2Id.value =0;
    refreshData(true);
  });

  const tabList = ref(null);
  const selectTabType = ref(0);

  const tag1List = ref(null);
  const selectTag1Id = ref(0);

  const tag2List = ref(null);
  const selectTag2Id = ref(0);

  function clickTab(tabType){
    selectTabType.value = tabType;
    refreshData(true);
  }
  function clickTag1(tag1Id){
    selectTag1Id.value = tag1Id;
    refreshData();
  }
  function clickTag2(tag2Id){
    selectTag2Id.value = tag2Id;
    refreshData();
  }

  function findItemList(resp,isRestTag=true) {
    let targetList = [];
    let leftDataList = resp["CurNav"]["InnerChildNav"]??[];
    let curShowListData = resp["CurNav"]["CurChildNav"];
    for (let i = 0; i < leftDataList.length; i++) {
      if (curShowListData["Id"] === leftDataList[i]["Id"]) {
        targetList = leftDataList[i]["ItemList"]??[];

        if(isRestTag){
          tabList.value  = leftDataList[i]["TabList"];
          tag1List.value  = leftDataList[i]["Tag1List"];
          if(tag1List.value && tag1List.value.length>0){
            tag1List.value.unshift({
              Id:0,
              Name:"全部",
            });
          }
          tag2List.value = leftDataList[i]["Tag2List"];
          if(tag2List.value && tag2List.value.length>0){
            tag2List.value.unshift({
              Id:0,
              Name:"全部",
            });
          }
        }
        break;
      }
    }

    let shouldGameItemList = [];
    //清洗数据
    for(let i = 0;i<targetList.length;i++){
      let eachTemplateInfo = targetList[i];
      shouldGameItemList.push({
        "Id": eachTemplateInfo["GameId"],
        "Icon": eachTemplateInfo["Icon"],
        "Title": eachTemplateInfo["Title"],
        "Status": eachTemplateInfo["Status"],
        "IconLogo": eachTemplateInfo["IconLogo"],
        "IconLogoType": eachTemplateInfo["IconLogoType"],
        "FavoriteState": eachTemplateInfo["FavoriteState"],
        "FavoriteCallback":props.childNavId === 64?refreshData:null,
        "ClickType": 1,
        "ClickParam": eachTemplateInfo["GameId"],
        "leaveArgument": {
          "InnerNavId": props.innerNavId,
          "ChildNavId": props.childNavId,
        },
      });
    }
    return shouldGameItemList;
  }

  function refreshData(isRestTag = false){
    loading.value = true;
    refreshing.value = false;
    finished.value = false;
    list.value = [];
    onLoad(isRestTag);
  }

  function onLoad(isRestTag = false) {
    if (refreshing.value) {
      list.value = [];
      refreshing.value = false;
    }

    useHttp.request('/qp/game/inner-lobby', (resp) => {
      let listData = findItemList(resp["Data"],isRestTag);
      loading.value = false;
      list.value = [...list.value, ...(listData ?? [])];
      if (!listData || listData.length < 24) {
        finished.value = true;
      }
    }, {
      params: {
        Start: list.value.length,
        Limit: 24,
        AppId: user.appId,
        AppUserId: user.userId,
        InnerNavId: props.innerNavId,
        ChildNavId: props.childNavId,
        TabType: selectTabType.value,
        Tag1Id: selectTag1Id.value,
        Tag2Id: selectTag2Id.value,
      },
      forceToastErrorMsg: true,
      isShowLoading: false,
    });
  }

  function onRefresh() {
    list.value = [];
    finished.value = false;
    loading.value = true;
    onLoad();
  }
</script>

<style scoped>
</style>
